import { UtilsShop } from "../../../../../shop/frontend/web/js/utils";

class Utils extends UtilsShop {
	constructor() {
		super();
	}

	toTop(items) {
		if (!items.length) {
			return false;
		}
		const eventTop = $(".js-to-top");
		let needCorrect = 150;
		const top = items.offset().top - needCorrect;
		const screenHeight = window.screen.height;

		eventTop.on("click", () => {
			window.scrollTo({
				top,
				behavior: "smooth",
			});

			eventTop.removeClass("active");
		});
		$(document).on("scroll", () => {
			if ($(window).scrollTop() > screenHeight / 2) {
				eventTop.addClass("active");
			} else {
				eventTop.removeClass("active");
			}
		});
	}
}

export const utils = new Utils();
